import React from 'react';

const EmptyState = ({ title = 'No data found' }) => {
	return (
		<div className="empty-section d-flex flex-column justify-content-center align-items-center">
			<p className="medium-14 gray_dark_02 text-center">{title}</p>
		</div>
	);
};

export default EmptyState;
